const s = {
	item: 'skeleton-item',
	inline: 'inline',
	block: 'block',
	xs: 'xs',
	sm: 'sm',
	md: 'md',
	lg: 'lg',
	xl: 'xl',
}

const skeleton = ({ className = '', layout = 'inline', size = 'md', ...rest } = {}) => {
  const computeType = (): string => {
    switch (layout) {
      case 'inline':
        return `${s.inline}`;
      case 'block':
        return `${s.block}`;
      default:
        return '';
    }
  };
  const computeSize = (): string => {
    switch (size) {
      case 'xs':
        return `${s.xs}`;
      case 'sm':
        return `${s.sm}`;
      case 'md':
        return `${s.md}`;
      case 'lg':
        return `${s.lg}`;
      case 'xl':
        return `${s.xl}`;
      default:
        return '';
    }
  };
  
  return `<div class="${[s.item, className, computeType(), computeSize()].join(' ').trim()}" style="${Object.keys(rest).map(property => `${property}:${(rest as any)[property]}`).join(';')}"></div>`
}

export default skeleton;